import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "../../hooks";
import { Container, Col, Row, Stack } from "react-bootstrap";

import styles from './Home.module.css'

type PromptResult = {
  id: string;
  created_at: string;
  current_step: string;
}

export default function Home() {
  const navigate = useNavigate()
  const { data } = useQuery("prompt_results");
  const createPrompt = useMutation("prompt_results");


  function handleStart() {
    createPrompt.mutate(undefined, { onSuccess: onStartSuccess });
  }

  function onStartSuccess(data: PromptResult) {
    if (data.id) {
      navigate(`/exercise/${data.id}`)
    }
  }

  function renderStatus(item: PromptResult) {
    switch (item.current_step) {
      case 'complete':
        return "Results Complete"
      default:
        return "Started"
    }
  }

  function renderExercise(item: PromptResult, index: number) {
    const link = item.current_step === 'complete' ? `/exercise/${item.id}/results` : `/exercise/${item.id}`
    return (
      <Col xs="12" sm="6" md="4" key={index}>
        <Link to={link} className={styles.cardLink}>
          <div className={styles.card}>
            <p>{item.created_at}</p>
            <p>{renderStatus(item)}</p>
          </div>
        </Link>
      </Col>
    )
  }

  return (
    <div>
      <Container>
        <Stack gap={3}>
          <Row className="justify-content-center">
            {data?.map(renderExercise)}
          </Row>
          <Row className="justify-content-center">
            <Col xs="6">
              <button className="button wide" onClick={handleStart}>Start New Exercise</button>
            </Col>
          </Row>
        </Stack>
      </Container>
    </div>
  );
}
